<template>
  <section class="container contact-container">
    <div class="row justify-content-center mt-4">
      <div class="col-12 col-md-10"> <!-- Increased width for a bigger Calendly -->
        <h3 class="text-center">Schedule an Appointment</h3>
        <div class="calendly-container">
          <iframe
            src="https://calendly.com/delgadoharold58/30min"
            class="calendly-iframe"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contact-container {
  padding: 40px 20px;
}

.contact-container p {
  font-size: 18px;
  margin-bottom: 10px;
}

/* Larger Calendly Embed & Full Page Scrolling */
.calendly-container {
  width: 100%;
  height: 600px; /* Increased height for better visibility */
  display: flex;
  justify-content: center;
}

.calendly-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .calendly-container {
    height: 500px; /* Slightly smaller for mobile */
  }
}

@media (max-width: 480px) {
  .calendly-container {
    height: 450px; /* Smaller view for very small screens */
  }
}
</style>
